import { warehouseClient } from "@/infrastructure/http/warehouseClient";
import type { TenantUsageData, TenantUsageResponse } from "@/domain/types";

export async function getTenantUsage(): Promise<TenantUsageData | null> {
  const response = await warehouseClient.get<TenantUsageResponse>("/tenant-usage");
  return response.data.data;
}
